import classNames from 'classnames/bind'
import styles from './ContentListItem.module.scss'
import { FreeContent } from './type'

const cx = classNames.bind(styles)

export const ContentListItem = ({ tag, title, link }: FreeContent) => {
  return (
    <a className={cx('container')} href={link} target="_blank" rel="noreferrer">
      <div className={cx('badge', tag)}>
        <span>{tag}</span>
      </div>
      <p className={cx('title')}>{title}</p>
    </a>
  )
}
